import React from "react";
import { Route, Redirect } from "react-router-dom";
import Helmet from "react-helmet";
import {
  IonApp,
  IonRouterOutlet,
  IonTabBar,
  IonTabs,
  IonTabButton,
  IonIcon,
  IonLabel,
} from "@ionic/react";
import { IonReactHashRouter } from "@ionic/react-router";
import { Routes } from "./routes";
import { squareOutline, search } from "ionicons/icons";
import { Home } from "./pages/Home";
import { ChallengeDetail } from "./pages/ChallengeDetail";
import { ThemesPage } from "./pages/ThemesPage";
import { Explore } from "./pages/Explore";
import { NotFoundPage } from "./pages/NotFoundPage";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";

const App: React.FC = () => (
  <>
    <IonApp>
      <IonReactHashRouter>
        <IonTabs>
          <IonRouterOutlet>
            <Route exact path={Routes.HomePage} component={Home} />
            <Route exact path={Routes.ExplorePage} component={Explore} />
            {/* <Route exact path={Routes.CreatePage} component={CreateChallenge} /> */}
            <Route
              path={`${Routes.HomePage}/:id`}
              component={ChallengeDetail}
            />
            <Route
              exact
              path="/"
              render={() => <Redirect to={Routes.HomePage} />}
            />
            <Route path={`${Routes.ThemesPage}/:id`} component={ThemesPage} />
            <Route component={NotFoundPage} />
          </IonRouterOutlet>
          <IonTabBar slot="bottom">
            <IonTabButton tab="challenges" href={Routes.HomePage}>
              <IonIcon icon={squareOutline} />
              <IonLabel>Challenges</IonLabel>
            </IonTabButton>
            <IonTabButton tab="explore" href={Routes.ExplorePage}>
              <IonIcon icon={search} />
              <IonLabel>Explore</IonLabel>
            </IonTabButton>
            {/* <IonTabButton tab="create" href={Routes.CreatePage}>
            <IonIcon icon={addCircleOutline} />
            <IonLabel>Create</IonLabel>
          </IonTabButton> */}
          </IonTabBar>
        </IonTabs>
      </IonReactHashRouter>
    </IonApp>
    <Helmet>
      {/* <!-- HTML Meta Tags --> */}
      <meta name="description" content="Helpo" />

      {/* <!-- Facebook Meta Tags --> */}
      <meta property="og:url" content="" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Helpo" />
      <meta
        property="og:description"
        content="Helpo empowers positive social change by providing digital interventions for wellbeing, providing self-care through social challenge and therapeutic programs coupled with digital behaviour change."
      />
      <meta
        property="og:image"
        content="assets/ShareButtons/button-share-facebook.png"
      />

      {/* <!-- Twitter Meta Tags --> */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Helpo" />
      <meta
        name="twitter:description"
        content="Helpo empowers positive social change by providing digital interventions for wellbeing, providing self-care through social challenge and therapeutic programs coupled with digital behaviour change."
      />
      <meta
        name="twitter:image"
        content="assets/ShareButtons/button-share-twitter.png"
      />
    </Helmet>
  </>
);

export default App;
